/**
 * TAPSODY - OFFICIAL POPUNIE GENRE TAXONOMY
 * Two-tier structure: Main categories → Specific sub-genres
 * Source: PopUnie Netherlands (120 official genres)
 */

export const GENRE_CATEGORIES = {
  metal: {
    name: 'Metal',
    icon: '🎸',
    subgenres: [
      'Death metal',
      'Doom metal',
      'Heavy metal',
      'Djent metal',
      'Power metal',
      'Suicidal black metal',
      'Math metal',
      'Speed metal',
      'Trash metal',
      'Rap metal',
      'Prog metal',
      'Nu-metal',
      'Sludge metal',
      'Metalcore',
      'Metal/Punk crossover'
    ]
  },
  
  rock: {
    name: 'Rock',
    icon: '🎸',
    subgenres: [
      'Indie rock',
      'Blues rock',
      'Funk rock',
      'Folk rock',
      'Country rock',
      'Guitar rock',
      'Pop rock',
      'Symphonic rock',
      'Noise rock',
      'Progressive rock',
      'Stoner rock',
      'Grunge',
      'Rock \'n Roll',
      'Rockabilly',
      'Rock crossover'
    ]
  },
  
  punk: {
    name: 'Punk/Hardcore',
    icon: '🎤',
    subgenres: [
      'Hardcore',
      'Skate-punk',
      'Ska-punk',
      'Art punk',
      'Post punk',
      'Old school punk',
      'Straight edge',
      'Emocore',
      'Punkrock (\'n roll)'
    ]
  },
  
  electronic: {
    name: 'Electronic/Dance',
    icon: '🎹',
    subgenres: [
      'House',
      'Techno',
      'Trance',
      'Hardhouse',
      'Techhouse',
      'Deephouse',
      'Drum \'n bass',
      'Electro',
      'Ambient/chill',
      'Acid',
      'Chemical/big beatz',
      'Progressive',
      'Garage',
      '2-step',
      'Ragga',
      'Club',
      'Trip hop',
      'Electronic soundscapes',
      'Dance crossover'
    ]
  },
  
  pop: {
    name: 'Pop',
    icon: '🎵',
    subgenres: [
      'Guitar pop',
      'Brit pop',
      'Wave pop',
      'Indie pop',
      'Funky pop',
      'Ska pop',
      'Pop rock',
      'Pop crossover'
    ]
  },
  
  jazz_soul_funk: {
    name: 'Jazz/Soul/Funk',
    icon: '🎺',
    subgenres: [
      'Jazz',
      'Blues',
      'Soul',
      'Nu-soul',
      'Funk',
      'P-funk',
      'R&B',
      'Swingbeat',
      'Jazzdance',
      'Nu-tech-jazz'
    ]
  },
  
  hiphop_urban: {
    name: 'Hip Hop/Urban',
    icon: '🎤',
    subgenres: [
      'Hiphop',
      'R&B',
      'Hindipop'
    ]
  },
  
  world: {
    name: 'World Music',
    icon: '🌍',
    subgenres: [
      'Reggae (Roots)',
      'Authentic-ska',
      'Samba',
      'Bossa-nova',
      'Axê',
      'Samba-reggae',
      'Afro-Cuban',
      'Son',
      'Salsa',
      'Lando',
      'Steel/Calypso',
      'Meringue',
      'Raï',
      'Chaabi',
      'Gnaoua',
      'Kawina',
      'Kaseko',
      'Kaskawina',
      'Tango',
      'Mbalax',
      'Soucous',
      'Afrobeat',
      'Non-Western crossover',
      'Disco',
      'Global beatz lounge'
    ]
  },
  
  other: {
    name: 'Other',
    icon: '🎭',
    subgenres: [
      'Folk (Dutch)',
      'Country',
      'Americana',
      'Cajun',
      'Zydeco',
      'Singer/Songwriter',
      'Experimental',
      'Avant-garde',
      'Gothic',
      'Industrial',
      'Noise',
      'Christian',
      'Kids/family'
    ]
  },
  
  party_covers: {
    name: 'Party/Covers',
    icon: '🎉',
    subgenres: [
      'Covers/tribute',
      'Wedding and party music',
      'Party music',
      'DJ'
    ]
  }
};

// Helper function to get all genres as flat array
export function getAllGenres() {
  const allGenres = [];
  Object.values(GENRE_CATEGORIES).forEach(category => {
    allGenres.push(...category.subgenres);
  });
  return allGenres.sort();
}

// Helper function to get category from specific genre
export function getCategoryForGenre(genre) {
  for (const [key, category] of Object.entries(GENRE_CATEGORIES)) {
    if (category.subgenres.includes(genre)) {
      return key;
    }
  }
  return null;
}

// Dutch regions for location selection
export const DUTCH_REGIONS = [
  'Noord Holland',
  'Zuid Holland',
  'Noord Brabant',
  'Gelderland',
  'Utrecht',
  'Overijssel',
  'Limburg',
  'Groningen',
  'Friesland',
  'Zeeland',
  'Flevoland',
  'Drenthe'
];

// Major Dutch cities for quick selection
export const MAJOR_CITIES = [
  'Amsterdam',
  'Rotterdam',
  'Den Haag',
  'Utrecht',
  'Eindhoven',
  'Groningen',
  'Tilburg',
  'Almere',
  'Breda',
  'Nijmegen',
  'Enschede',
  'Haarlem',
  'Arnhem',
  'Zaanstad',
  'Amersfoort',
  'Leiden',
  'Dordrecht',
  'Delft',
  'Maastricht'
];
